import sharedFilter from './shared';

export default {
  pageFilters: [
    {
      id: 'content',
      label: 'Content',
      filters: {
        show: null
      }
    },
    {
      id: 'users',
      label: 'Users',
      filters: {
        country: null,
        panel: sharedFilter.sampleBalance,
        age: null,
        gender: null
      }
    },
    {
      id: 'date',
      label: 'Date',
      filters: {
        date: null
      }
    },
    {
      id: 'segments',
      label: 'Saved Filters',
      filters: {
        segments: sharedFilter.segments
      }
    }
  ],
  queries: {
    audienceRatings: {
      fields: ['show', 'age', 'gender', 'country', 'panel', 'date']
    },
    showFollowers: {
      fields: ['show', 'country', 'age', 'gender', 'panel']
    },
    showSampleSize: {
      fields: ['show', 'country', 'date', 'age', 'gender', 'panel']
    },
    showFavorites: {
      fields: [
        'country',
        'date',
        'show',
        'age',
        'gender',
        'genre',
        'network',
        'panel'
      ]
    },
    showMobility: {
      fields: ['country', 'date', 'age', 'gender', 'show', 'panel']
    },
    audienceShowViewAge: {
      fields: ['country', 'date', 'gender', 'show', 'panel']
    },
    audienceShowViewCountry: {
      fields: ['age', 'date', 'gender', 'show', 'viewers', 'panel']
    },
    audienceShowViewGender: {
      fields: ['age', 'date', 'country', 'show', 'panel']
    },
    audiencePlatform: {
      fields: ['age', 'date', 'country', 'show', 'gender', 'panel']
    }
  }
};
